//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'nav-bar',
  components: {},
  props: ['title', 'back'],
  mounted() {
  },
  methods: {
    goBack() {
      if (this.back) {
        console.log('this.back', this.back);
        this.$router.push(this.back);
      } else {
        if (window.history.length >= 1) {
          this.$router.go(-1);
        } else {
          this.$router.replace('/');
        }
      }
    }
  },
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/components/NavBar.vue